import { Box, BoxProps } from '@chakra-ui/react';
import sanitizeHtml from 'sanitize-html';

type HtmlParserProps = {
  html: string;
  asSpan?: boolean;
};

export function HtmlParser({
  html,
  asSpan = true,
  ...rest
}: HtmlParserProps & BoxProps): JSX.Element {
  return (
    <Box
      as={asSpan ? 'span' : 'div'}
      sx={{
        ' &>a': { color: 'palette_blue.100', textDecoration: 'underline' }
      }}
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(html, {
          allowedTags: ['a', 'b', 'strong', 'br', 'i', 'ol', 'li']
        })
      }}
      {...rest}
    />
  );
}
